<!--
  Metadata-driven read pane of ONE cp runtime row. The four states of fe_core_ux-guidelines are
  all covered: loading (skeleton), empty (no row selected), error (row unreadable) and ready.

  BT-12 splits the pending statement in two: each affected FIELD carries the bare fact
  „nicht berechnet“ inside the widget, and the explanation of the normal case sits ONCE at
  the head of the block. An engine field is empty in three different situations and only one of
  them has a run coming, so the per-field text must not promise one.
-->
<div class="cp-provision-object-data">

    @if (!initialized || busy) {
        <p-skeleton height="12rem"></p-skeleton>
    } @else if (!objectId) {
        <p-message severity="info" [text]="emptyText" styleClass="w-full"></p-message>
    } @else if (loadFailed) {
        <p-message severity="error" text="Der Datensatz konnte nicht geladen werden."
                   styleClass="w-full"></p-message>
    } @else if (dataWidget) {

        @if (pendingNoteVisible) {
            <p-message severity="info" [text]="pendingNote" styleClass="w-full mb-3"></p-message>
        }

        <mvs-widget [widgetData]="dataWidget"></mvs-widget>
    }

</div>
